module.exports = __webpack_public_path__ + "static/media/t3.d1068e01.png";